<template>
  <div class="col-12 p-0 d-flex justify-content-between">
    <div
      class="liked"
      :class="{
        'text-danger': isLiked
      }"
      @click="setLikeStatus"
    >
      <i class="far fa-heart"></i>&nbsp;<small>Gostei</small>
    </div>
    <b class="qty-like" v-if="likes > 1">{{ likes }} pessoas gostaram</b>
    <b class="qty-like" v-if="likes == 1">{{ likes }} pessoa gostou</b>
  </div>
</template>

<script>
import Axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  props: {
    postID: {
      required: true,
    },
    liked: {
      default: false
    },
    qtyLikes: {
      default: 0
    }
  },
  data () {
    return {
      postLiked: undefined,
      likes: 0,
    }
  },
  computed: {
    isLiked: function () {
      return this.postLiked
    },
    ...mapGetters({
      user: "getCurrentUser"
    })
  },
  methods: {
    setLikeStatus: function () {
      this.postLiked = !this.postLiked

      if ( this.postLiked ) this.likes += 1
      else this.likes -= 1

      Axios.post('/likeit', {
        post: this.postID,
        user: this.user.id,
        reaction: 'LK',
      })
        .catch( err => {
          console.error( err )
        })
    }
  },
  mounted () {
    this.postLiked = this.liked
    this.likes = this.qtyLikes
  }
}
</script>

<style>

</style>
